import translations from './translations'

translations.add('es', {
    changePaymentMethod: 'cambiar método de pago',
    firstTokenizationDescription: 'Registro de tarjeta',
    firstVerificationDescription: 'Verificación de tarjeta',
    secondaryOrderInfoDescription: 'No se le cobrará',
    tryAgain: 'Intentar otra vez'
})
